import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=2e54abfa&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=js&"
export * from "./sideBar.vue?vue&type=script&lang=js&"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=2e54abfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54abfa",
  null
  
)

export default component.exports